import React from "react"
import "./title.css"

const Title = ({ name = 'title' }) => {
  return (
    <div className='title'>
      <h4>{name}</h4>
    </div>
  )
}

export default Title
